<template>
	<section>
		<img
			:src="require('../../public/icons/Burger-Menu.svg')" width="48"
			alt="Humberger Menu" id="burger-menu"
			@click="isMenuOpened=!isMenuOpened"
		>

		<div :class="{'menu':true,'opened':isMenuOpened}">
			<router-link to="/">
				<img
					:src="require('../../public/icons/Logo.svg')"
					width="200px"
					alt="Mustafa ALTIN Logo"
					id="logo"
				>
			</router-link>
			<router-link :to="item.path"
				v-for="(item, index) in list"	:key="index"
				:class="{'header-item':true,'selected':$route.path===item.path}"
			>
				{{ item.nameTR }}
			</router-link>
		</div>

	</section>
</template>

<script>
	export default {
		name: 'Menu',
		
		data(){
			return {
				list: [
					{
						name: 'hakkimda',
						nameTR: 'Hakkımda',
						path: '/',
					},

					{
						name: 'kitaplik',
						nameTR: 'Kitaplık',
						path: '/Kitaplik',
					},

					{
						name: 'yayinlar',
						nameTR: 'Yayınlar',
						path: '/Yayinlar',
					},

					{
						name: 'projeler',
						nameTR: 'Projeler',
						path: '/Projeler',
					},

					{
						name: 'ders_programi',
						nameTR: 'Ders Programı',
						path: '/Ders-Programi',
					},

					{
						name: 'oduller',
						nameTR: 'Ödüller',
						path: '/Oduller',
					},

					{
						name: 'patentler',
						nameTR: 'Patentler',
						path: '/Patentler',
					},

					{
						name: 'uyelikler',
						nameTR: 'Üyelikler',
						path: '/Uyelikler',
					},

					{
						name: 'gorevler',
						nameTR: 'Görevler',
						path: '/Gorevler',
					},
				],
				isMenuOpened: false,
			};
		},
	}
</script>

<style lang="scss" scoped>
	section{
		#burger-menu{
			margin: 10px;

			&:hover{
				cursor: pointer;
			}
		}

		.menu{
			display: flex;
			flex-direction: column;
			margin: 1em;

			@media screen and (max-width: 768px){
				&.opened{
					display: flex;
				}

				display: none;
			}

			#logo{
				width: 200px;
				transition: width 1s;

				&:hover{
					cursor: pointer;
					transition: width 1s;
					width: 215px;
				}
			}

			.header-item {
				text-align: left;
				color: #F2F2F2;
				padding: 12px;
				font-size: 15pt;
				transition: font-size 1s, font-weight 1s;

				&:hover {
					transition: font-size 1s, font-weight 1s;
					font-size: 20pt;
				}

				&.selected {
					font-size: 20pt;
					font-weight: 700;
					transition: font-size 1s, font-weight 1s;
				}
			}
		}

		@media screen and (min-width: 768px){
			#burger-menu{
				visibility: hidden;
			}
		}

		@media screen and (max-width: 768px){
			#burger-menu{
				visibility: visible;
			}
		}	
	}
</style>